import React from 'react';

import packageData from '../../../package.json';

export default function Version() {
    return (
        <div id='version'>v{packageData.version}</div>
    );
}
